import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';
import { PieChartProps } from './pie-chart.prop';

ChartJS.register(ArcElement, Tooltip, Legend);

function PieChart({ data, labelDisplay }: PieChartProps) {
  const isEmptyData = !data || data.length === 0;

  const defaultData = [
    {
      label: 'Empty',
      value: 1,
      color: '#f0f0f0',
      cutout: '50%',
    },
  ];

  const blueShades = [
    '#0A1D4E', // deep navy blue
    '#102A75', // darker navy
    '#1E3A8A', // dark blue
    '#254DCA', // medium-dark blue
    '#2563EB', // standard blue
    '#3B82F6', // sky blue
    '#4F91F9', // mid-sky blue
    '#60A5FA', // light blue
    '#72B8FB', // softer blue
    '#93C5FD', // lighter blue
    '#A5D2FE', // pastel blue
    '#BFDBFE', // pale blue
    '#D1E5FE', // very pale blue
    '#DBEAFE', // extra light blue
    '#E8F1FF', // near-white blue
    '#EFF6FF', // ultra light blue
  ];

  const chartData = isEmptyData ? defaultData : data;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const options: any = {
    plugins: {
      responsive: true as boolean,
      legend: {
        display: labelDisplay,
      },
      tooltip: {
        enabled: !isEmptyData,
      },
      cutout: '50%',
    },
    cutout: chartData?.map((item) => item.cutout),
  } as const;

  const finalData = {
    labels: chartData?.map((item) => item.label),
    datasets: [
      {
        data: chartData?.map((item) => item.value || 0),
        backgroundColor: chartData?.map(
          (_, index: number) => blueShades[index % blueShades.length],
        ),
        borderColor: chartData?.map((_, index: number) => blueShades[index % blueShades.length]),
        borderRadius: 4,
        spacing: 8,
        borderWidth: 1,
        dataVisibility: new Array(chartData?.length).fill(true),
      },
    ],
  };

  return <Doughnut data={finalData} options={options} />;
}

export default PieChart;
